import { memo, useState, useEffect } from 'react'

import { useSelector } from 'react-redux'

import { Chip, Button } from '@mui/material'
import BackButton from './BackButton'

export default memo(({ classes, isAppointment = false, selectedPeriode, setSelectedPeriode, addPanier, setStepContents, goBack, selectedCentre, selectedActivite, selectedAbonne, getPricesItem }) => {

  const [periodes, setPeriodes] = useState([])
  const state = useSelector(state => state)

  useEffect(async () => {
    const item = {
      licencie: selectedAbonne,
      centre: selectedCentre,
      activite: selectedActivite
    }

    const prices_data = await getPricesItem(item)
    setPeriodes(prices_data)

  }, [])

  function handleRadioChange(event) {
    const p = event.target.id
    setSelectedPeriode({ libelle: p, ...periodes[p] })

    setStepContents(previous => {
      const newStepContents = [...previous]
      if (p == 'trimestre') newStepContents[2] = 'Trimestre'
      if (p == 'saison') newStepContents[2] = 'Saison'
      if (p == 'mois') newStepContents[2] = 'Mois'
      if (p == 'annee') newStepContents[2] = 'Année'
      return newStepContents
    })
  }

  return (
    <>
      <p>Choisissez une période d’abonnement :</p>
      <div className={classes.radios}>
        {selectedActivite.ACT_ID === '7F8D84B4-C9F5-40E4-B8B3-FE69CB2B3803'
          ? <>
            <div>
              <input type="radio" name="periode" id="mois" onChange={handleRadioChange} ></input>
              <Button variant="outlined" sx={{ minHeight: '210px', alignItems: 'start' }}>
                <label htmlFor="mois">
                  <h3>Mois</h3>
                  {periodes?.mois && (<>
                    <p>Du <b>{new Date(periodes?.mois.dates.DATE_DEBUT).toLocaleDateString('fr-FR')}</b></p>
                    <p>Au <b>{new Date(periodes?.mois.dates.DATE_FIN).toLocaleDateString('fr-FR')}</b></p>
                    <p className="prix">{periodes?.mois.price}€</p>
                  </>)}
                </label>
              </Button>
            </div>
            <div>
              <input type="radio" name="periode" id="annee" onChange={handleRadioChange} />
              <Button variant="outlined" sx={{ minHeight: '210px', alignItems: 'start' }}>
                <label htmlFor="annee">
                  <h3>Année</h3>
                  {periodes?.annee && (<>
                    <p>Du <b>{new Date(periodes?.annee.dates.DATE_DEBUT).toLocaleDateString('fr-FR')}</b></p>
                    <p>Au <b>{new Date(periodes?.annee.dates.DATE_FIN).toLocaleDateString('fr-FR')}</b></p>
                    <p className="prix">{periodes?.annee.price}€</p>

                  </>)}
                </label>
              </Button>

            </div>
          </>
          : <>
            {periodes?.trimestre && !isAppointment && (<>
              <div>
                <input type="radio" name="periode" id="trimestre" onChange={handleRadioChange} ></input>
                <Button variant="outlined" sx={{ minHeight: '210px', alignItems: 'start' }}>
                  <label htmlFor="trimestre">
                    <h3>Trimestre</h3>
                    <p>Du <b>{new Date(periodes?.trimestre.dates.DATE_DEBUT).toLocaleDateString('fr-FR')}</b></p>
                    <p>Au <b>{new Date(periodes?.trimestre.dates.DATE_FIN).toLocaleDateString('fr-FR')}</b></p>
                    <p className="prix">{periodes?.trimestre.price}€</p>
                  </label>
                </Button>
                <div className={classes.types}>
                  {periodes?.trimestre &&
                    periodes.trimestre.types.map((type, i) => (<Chip
                      component="p"
                      key={i}
                      size="size"
                      label={type}
                    />))
                  }
                </div>
              </div>
            </>)}
            {!state.interruptionSaison && (<>
              {periodes?.saison && (<>
                <div>
                  <input type="radio" name="periode" id="saison" onChange={handleRadioChange} />

                  <Button variant="outlined" sx={{ minHeight: '210px', alignItems: 'start' }}>
                    <label htmlFor="saison">
                      <h3>Saison</h3>
                      <p>Du <b>{new Date(periodes?.saison.dates.DATE_DEBUT).toLocaleDateString('fr-FR')}</b></p>
                      <p>Au <b>{new Date(periodes?.saison.dates.DATE_FIN).toLocaleDateString('fr-FR')}</b></p>
                      <p className="prix">{periodes?.saison.price}€</p>
                    </label>
                  </Button>

                  <div className={classes.types}>
                    {periodes?.saison &&
                      periodes.saison.types.map((type, i) => (<Chip
                        component="p"
                        key={i}
                        size="size"
                        label={type}
                      />))
                    }
                  </div>
                </div>
              </>)}
            </>)}
          </>}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <BackButton back={goBack} />
        <Button
          style={{ marginTop: 16, width: 'fit-content' }}
          onClick={addPanier}
          disabled={!selectedPeriode}
          variant="contained"
          disableElevation
        >Ajouter au panier</Button>

      </div>
    </>
  )
})
